<template>
  <div class="col-md-12 p-0 contract-create-page contract-renewal-page">
    <!-- popup shift wark -->
    <div class="popup popup-sm contract-create-modal contract-create-modal--shift" v-if="isEnablePopup == 'shiftwork'">
      <div class="content">
        <h5>
          Shift Worker <br /><small class="text-secondary"
            >Set shift name, start hour, and working hours, then click "Add New" to
            generate new shift work</small
          >
        </h5>
        <hr />
        <div class="row p-0 mt-5">
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Shift Name</label><br />
              <select class="form-control" v-model="sw.name">
                <option value="">-- Choose One --</option>
                <option
                  v-for="shiftName in shiftNameOptions"
                  :key="shiftName.value"
                  :value="shiftName.value"
                  :disabled="isShiftNameUsed(shiftName.value)"
                >
                  {{ shiftName.label }}
                </option>
              </select>
              <!-- <input
                type="text"
                class="form-control"
                v-model="sw.name"
                placeholder="..."
              /> -->
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Start Shift Hour </label><br />
              <input
                type="time"
                class="form-control"
                v-model="sw.hour"
                placeholder="..."
              />
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <label>Working Hours</label><br />
              <select class="form-control" v-model.number="sw.working_hours">
                <option v-for="hour in workingHoursOptions" :key="hour" :value="hour">
                  {{ hour }} Hours
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <br />
              <a
                href="javascript:;"
                class="btn btn-secondary"
                @click="AddShiftWork()"
                >Add New</a
              >
            </div>
          </div>
        </div>
        <hr />
        <div
          class="legacy-shift-warning"
          v-if="duplicateShiftNames().length > 0"
        >
          <strong>Ditemukan nama shift duplikat dari kontrak lama.</strong>
          <span>
            Ubah nama shift {{ duplicateShiftNames().join(", ") }} yang
            duplikat di bawah. Jam mulai dan durasi kerja tidak akan berubah.
          </span>
        </div>
        <div class="row p-0">
          <div class="col-md-12">
            <span class="text-danger" v-if="this.sw.msg_error !== ''">{{
              this.sw.msg_error
            }}</span
            ><br />
            <div
              class="list-data renewal-shift-row"
              :class="{ 'renewal-shift-row--duplicate': isDuplicateShift(items.name) }"
              v-for="(items, idx) in this.sw.data"
              :key="idx"
            >
              <select
                class="shift-name-select"
                v-model="items.name"
                aria-label="Shift name"
              >
                <option
                  v-if="!isKnownShiftName(items.name)"
                  :value="items.name"
                >
                  {{ items.name }} (legacy)
                </option>
                <option
                  v-for="shiftName in shiftNameOptions"
                  :key="shiftName.value"
                  :value="shiftName.value"
                  :disabled="isShiftNameUsedByOther(shiftName.value, idx)"
                >
                  {{ shiftName.label }}
                </option>
              </select>
              <span class="shift-time-label">{{ items.hour }}</span>
              <select class="shift-hours-select" v-model.number="items.working_hours">
                <option v-for="hour in workingHoursOptions" :key="hour" :value="hour">{{ hour }} hours</option>
              </select>
              <i
                class="ti ti-trash text-danger"
                @click="RemoveShiftWorker(idx)"
              ></i>
            </div>
          </div>
        </div>
        <hr />
        <div class="row p-0 mb-5">
          <div class="col-md-12">
            <a
              href="javascript:;"
              class="btn btn-primary float-right"
              @click="isEnablePopup = false"
              >Finish & Close</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup man power -->
    <div class="popup popup-sm contract-create-modal contract-create-modal--compact" v-if="isEnablePopup == 'manpower'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5>
          Generate Man Power <br /><small class="text-secondary"
            >Click button "Add New" to generate new man power</small
          >
        </h5>
        <hr />
        <div class="row p-0">
          <div class="col-md-2 p-0">
            <div class="form-group">
              <label>Total</label><br />
              <input
                type="number"
                min="1"
                class="form-control"
                placeholder="0"
                v-model="mp.total"
              />
            </div>
          </div>
          <div class="col-md-7 p-0">
            <div class="form-group">
              <label>Job Position</label><br />
              <select class="form-control" v-model="mp.job">
                <option value="">-- Choose One --</option>
                <option v-for="(items, idx) in model_jobpos" :key="idx">
                  {{ items.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="form-group">
              <br />
              <a
                href="javascript:;"
                class="btn btn-secondary"
                @click="AddMoreManPower()"
                >Add New</a
              >
            </div>
          </div>
        </div>
        <div class="row p-0 mb-5">
          <div class="col-md-11">
            <span class="text-danger" v-if="this.mp.msg_error !== ''">
              {{ this.mp.msg_error }} </span
            ><br />
            <h5></h5>
            <div
              class="list-data"
              v-for="(items, idx) in this.mp.data"
              :key="idx"
            >
              - {{ items.total }} ( {{ items.job }} )
              <i
                class="ti ti-trash text-danger"
                @click="RemoveManPower(idx)"
              ></i>
            </div>
          </div>
        </div>

        <hr />
        <div class="row p-0 mb-5">
          <div class="col-md-12">
            <a
              href="javascript:;"
              class="btn btn-primary float-right"
              @click="isEnablePopup = false"
              >Finish & Close</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup section room  -->
    <div class="popup popup-md contract-create-modal contract-create-modal--section" v-if="isEnablePopup == 'section'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5>
          Section & Room <br /><small>Section Room Creator</small>
          <hr />
        </h5>
        <div class="row p-0">
          <div class="col-md-6">
            <span>Category </span>
            <select class="form-control" v-model="category_type">
              <option value="non_cleaning">Non Cleaning</option>
              <option value="cleaning">Cleaning</option>
            </select>
          </div>
          <div class="col-md-6">
            <span class="text-success float-left" id="add-more-notify"
              >1 slot unit is already created.</span
            >
            <a
              href="javascript:;"
              class="float-right btn btn-execute mb-5"
              @click="AddMoreSlotRoom()"
            >
              <i class="ti ti-plus text-success"></i> Add More Room</a
            >
            <br />
          </div>
        </div>
        <div
          class="row p-0 mb-2"
          v-for="(items, idx) in insertSections"
          :key="idx"
        >
          <div class="col-md-12">
            <div class="row" v-for="(items, idx) in items.data" :key="idx">
              <div class="col-md-2">
                <span>Floor</span>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="1"
                  v-model="items.area_floor"
                />
              </div>
              <div class="col-md-4">
                <span>Area Type </span>
                <select class="form-control" v-model="items.area_type">
                  <option value="indoor">InDoor</option>
                  <option value="outdoor">Outdoor</option>
                </select>
              </div>
              <div class="col-md-6">
                <span>Area Name</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="...."
                  v-model="items.area_name"
                />
              </div>
              <div class="col-md-12 mt-4">
                <span class="text-secondary">Area Job Description</span>
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="........"
                  v-model="items.area_task"
                ></textarea>
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div
          class="row mb-2"
          v-for="(items, idx) in editSections"
          :key="idx"
        >
          <div class="col-md-12">
            <div class="row" v-for="(items, idx) in items.data" :key="idx">
              <div class="col-md-2">
                <span>Floor</span>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="1"
                  v-model="items.area_floor"
                />
              </div>
              <div class="col-md-4">
                <span>Area Type </span>
                <select class="form-control" v-model="items.area_type">
                  <option value="indoor">InDoor</option>
                  <option value="outdoor">Outdoor</option>
                </select>
              </div>
              <div class="col-md-6">
                <span>Area Name</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="...."
                  v-model="items.area_name"
                />
              </div>
              <div class="col-md-12 mt-4">
                <span class="text-secondary">Area Job Description</span>
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="........"
                  v-model="items.area_task"
                ></textarea>
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div class="row p-0">
          <div class="col-md-12 mt-4 text-center">
            <a
              href="javascript:;"
              class="btn btn-primary"
              @click="SaveSectionRoom()"
              >{{
                popup_mode == "insert"
                  ? "Continue Add Section"
                  : "Update Section"
              }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- popup client  -->
    <PopupClientMaster
      class="contract-create-modal contract-create-modal--client"
      v-on:exit="closeClient"
      v-on:applyData="applyClient"
      :id_branch="model.id_branch"
      v-if="isEnablePopup == 'client'"
    />

    <div class="contract-create-hero contract-renewal-hero">
      <div>
        <small>CONTRACT MANAGEMENT</small>
        <h3>Renew Contract</h3>
        <p>Review the previous contract data and prepare the next contract period.</p>
      </div>
      <div class="contract-create-hero-icon" aria-hidden="true">
        <i class="ti ti-reload"></i>
      </div>
    </div>

    <form class="form-horizontal contract-create-form" @submit="submit">
      <div class="card contract-create-card">
        <div class="card-body">
          <div class="form-group contract-section-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Detail Information
                Contract</label
              >
              <small class="text-secondary"
                >Please fill completely detail data.</small
              >
              <hr />
            </div>
          </div>
          <div class="form-group" v-if="isEnableSelectBranch">
            <label class="col-sm-3"
              >Branch Station <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <SelectBranch
                v-on:processBranch="processBranch"
                :title="'disable'"
                :default_id="model.id_branch"
                :key="'renewal-branch-' + (model.id_branch || 'loading')"
              />
              <small class="text-danger" v-if="msg_error.id_branch">{{
                msg_error.id_branch[0]
              }}</small>
            </div>
          </div>
          <div class="form-group" v-else>
            <label class="col-sm-3"
              >Branch Station <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="branch_name"
                readonly
              />
              <small class="text-danger" v-if="msg_error.id_branch">{{
                msg_error.id_branch[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Number of Contract <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.contract_number"
              />
              <small class="text-danger" v-if="msg_error.contract_number">{{
                msg_error.contract_number[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Value (Amount)
              <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <vue-numeric
                separator="."
                output-type="String"
                currency="Rp"
                v-model="model.contract_value"
                class="form-control"
              ></vue-numeric>
              <small class="text-danger" v-if="msg_error.contract_value">{{
                msg_error.contract_value[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Date <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="date"
                class="form-control"
                placeholder="...."
                v-model="sdate"
              />
              <small class="text-danger" v-if="msg_error.contract_date">{{
                msg_error.contract_date[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Contract Period <small class="text-danger">*</small></label
            >
            <div class="col-sm-4">
              <span>Start Date</span>
              <input
                type="date"
                min="1"
                class="form-control"
                placeholder="0"
                v-model="model.start_date"
                id="startDate"
              />
              <small class="text-danger" v-if="msg_error.start_date">{{
                msg_error.start_date[0]
              }}</small>
            </div>
            <div class="col-sm-4 float-right">
              <span>End Date</span>
              <input
                type="date"
                min="1"
                class="form-control"
                placeholder="0"
                v-model="model.end_date"
                id="endDate"
              />
              <small class="text-danger" v-if="msg_error.end_date">{{
                msg_error.end_date[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">Need Feedback</label>
            <div class="col-sm-9">
              <div class="form-check mt-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="model.need_feedback"
                  :true-value="1"
                  :false-value="0"
                  id="need_feedback"
                />
                <label class="form-check-label" for="need_feedback">
                  Aktifkan agar klien mengisi feedback setelah layanan selesai
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3">Contract Description</label>
            <div class="col-sm-9">
              <small class="text-secondary"
                >Fill in the description fields as needed</small
              >
              <textarea
                class="form-control"
                rows="3"
                v-model="model.description"
              ></textarea>
              <small class="text-danger" v-if="msg_error.description">{{
                msg_error.description[0]
              }}</small>
            </div>
          </div>
          <div class="form-group contract-section-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Detail Information Client</label
              >
              <small class="text-secondary"
                >Please fill completely detail data.</small
              >
              <hr />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Client Base <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <select
                v-model="isBaseClient"
                class="form-control"
                @change="switchClientBase()"
              >
                <option value="new">New Client</option>
                <option value="old">Take From Resource Client</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="isBaseClient == 'old'">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <a
                href="javascript:;"
                class="btn btn-execute"
                @click="isEnablePopup = 'client'"
                ><i class="ti ti-server text-primary"></i>&nbsp; Browse Client
                ...</a
              >
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Client Name <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.name"
                :readonly="isBaseClient == 'old' ? true : false"
              />
              <small class="text-danger" v-if="msg_error.name">{{
                msg_error.name[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"
              >Email Address <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="email"
                class="form-control"
                placeholder="...."
                v-model="model.email"
                :readonly="isBaseClient == 'old' ? true : false"
              />
              <small class="text-danger" v-if="msg_error.email">{{
                msg_error.email[0]
              }}</small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3"
              >Phone Number <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="...."
                v-model="model.phone_number"
                :readonly="isBaseClient == 'old' ? true : false"
              />
              <small class="text-danger" v-if="msg_error.phone_number">{{
                msg_error.phone_number[0]
              }}</small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3"
              >Client Address <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                v-model="provinces_name"
                readonly
              />
              <small class="text-danger" v-if="msg_error.id_propinsi">{{
                msg_error.id_propinsi[0]
              }}</small>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <select
                v-model="model.id_kota"
                class="form-control"
                :disabled="model_kota.length > 0 ? false : true"
                :readonly="isBaseClient == 'old' ? true : false"
              >
                <option disabled value="">-- Pilih Kabupaten --</option>
                <option
                  v-for="(items, idx) in model_kota"
                  :value="items.id"
                  :key="idx"
                >
                  {{ items.name ? items.name : items.nama_kota }}
                </option>
              </select>
              <small class="text-danger" v-if="msg_error.id_kota">{{
                msg_error.id_kota[0]
              }}</small>
            </div>
          </div>
          <div class="form-group contract-map-row">
            <label class="col-sm-3"></label>
            <div class="col-sm-9">
              <Gmap
                name="example"
                :default_model="markerCoordinates"
                ref="Gmap"
                v-if="isAutoloadMaps"
              ></Gmap>
              <small class="text-danger" v-if="msg_error.office_address">{{
                msg_error.office_address[0]
              }}</small>
              <small class="text-danger" v-if="msg_error.lat">{{
                msg_error.lat[0]
              }}</small>
              <small class="text-danger" v-if="msg_error.lng">{{
                msg_error.lng[0]
              }}</small>
            </div>
          </div>

          <!-- new section client -->
          <div class="form-group contract-section-heading contract-area-heading">
            <div class="col-sm-12">
              <label class="text-primary mb-0"
                ><i class="ti ti-info-alt"></i> Client Station Area Base</label
              >
              <small class="text-secondary">Describe station area base.</small>
              <hr />
            </div>

            <div class="mt-2 contract-config-row">
              <div class="col-sm-3">
                Request Man Power
                <span class="badge badge-primary">{{
                  this.mp.data.length
                }}</span>
                <br />
                <small class="text-secondary"
                  >Setting Total Man Power and Job Position on Contract
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="OpenDialog('manpower')"
                  ><i class="ti ti-plus text-success"></i> Manage Man Power
                  ...</a
                >
                <br />
                <div class="mt-3" v-if="this.mp.data.length > 0">
                  <div
                    class="list-section"
                    v-for="(items, idx) in this.mp.data"
                    :key="idx"
                  >
                    - {{ items.total }} ( {{ items.job }} )
                  </div>
                </div>
                <small class="text-danger" v-if="msg_error.man_power">{{
                  msg_error.man_power[0]
                }}</small>
              </div>
            </div>

            <div class="mt-5 contract-config-row">
              <div class="col-sm-3">
                Total Shift Work :
                <span class="badge badge-primary">{{
                  this.sw.data.length
                }}</span
                ><br />
                <small class="text-secondary"
                  >Review and configure shifts for the renewed contract.
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="OpenDialog('shiftwork')"
                  ><i class="ti ti-plus text-success"></i> Manage Shift Work
                  ...</a
                >
                <br />
                <div
                  class="legacy-shift-warning legacy-shift-warning--summary mt-3"
                  v-if="duplicateShiftNames().length > 0"
                >
                  <strong>Nama shift harus unik.</strong>
                  <span>
                    Kontrak sebelumnya memiliki nama shift
                    {{ duplicateShiftNames().join(", ") }} yang duplikat. Buka
                    Kelola Shift Kerja dan ubah salah satunya sebelum melakukan
                    perpanjangan kontrak.
                  </span>
                </div>
                <div class="mt-3" v-if="this.sw.data.length > 0">
                  <div
                    class="list-section"
                    v-for="(items, idx) in this.sw.data"
                    :key="idx"
                  >
                    - {{ items.name }} ( {{ items.hour }} )
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5 contract-config-row contract-area-config">
              <div class="col-sm-3">
                Total Area :
                <span class="badge badge-primary">{{
                  data_section.length
                }}</span
                ><br />
                <small class="text-secondary"
                  >Review or add service areas for the renewed contract.
                </small>
              </div>
              <div class="col-sm-9">
                <a
                  href="javascript:;"
                  class="btn btn-light mb-1"
                  @click="AddMoreSection()"
                  ><i class="ti ti-plus text-success"></i> Manage New Section
                  ...</a
                >
              </div>

              <div
                class="row mt-3"
                v-for="(items_parent, index_parent) in data_section"
                :key="index_parent"
              >
                <div class="col-sm-3"></div>
                <div class="col-md-8">
                  <h5>
                    SECTION #{{ items_parent.section }}

                    <span
                      class="badge ml-2"
                      :class="
                        items_parent.category_type == 'cleaning'
                          ? 'badge-success'
                          : 'badge-secondary'
                      "
                    >
                      {{
                        items_parent.category_type == "cleaning"
                          ? "Cleaning"
                          : "Non Cleaning"
                      }}
                    </span>

                    <a
                      href="javascript:;"
                      class="float-right ml-3"
                      @click="EditSection(items_parent.section)"
                      ><i class="ti ti-pencil text-primary"></i
                    ></a>
                    &nbsp;<span class="text-light">|</span> &nbsp;
                    <a
                      href="javascript:;"
                      class="float-right"
                      @click="DeleteSection(index_parent)"
                      ><i class="ti ti-trash text-danger"></i
                    ></a>
                  </h5>
                  <div
                    v-for="(items, idx) in items_parent.data"
                    :key="idx"
                    :class="'form-group mt-2 initial-section'"
                  >
                    <div class="list-section">
                      {{ idx + 1 }} - Floor({{ items.area_floor }}),
                      {{ items.area_type }} - {{ items.area_name }}, Job Task
                      ({{ items.area_task == null ? "..." : items.area_task }})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- new section client -->
        </div>
      </div>
      <div class="row contract-create-actions">
        <div class="col-md-12 text-right">
          <a
            href="javascript:;"
            class="btn btn-secondary mr-3"
            @click="$router.go(-1)"
            >Cancel</a
          >

          <button
            type="submit"
            class="btn btn-primary btn-full-screen"
            :style="isSubmitting ? { cursor: 'progress', opacity: 0.7 } : {}"
          >
            <span v-if="isSubmitting">
              <i class="fa fa-spinner fa-spin"></i> Submitting...
            </span>
            <span v-else><i class="ti ti-reload"></i> Renew Contract</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import $ from "jquery";
import Gmap from "../../../services/Gmap";
import PopupClientMaster from "../../ClientBase/Master/@PopupClientMaster";
import SelectBranch from "../../Branch/@SelectBranch";

export default {
  components: {
    Gmap,
    PopupClientMaster,
    SelectBranch,
  },
  data() {
    return {
      meta_url: "contract",
      isSubmitting: false,
      isAutoloadMaps: true,
      isBaseClient: "old",
      isEnablePopup: false,
      isEnableSelectBranch: false,
      sdate: new Date(Date.now() + -6 * 24 * 3600 * 1000)
        .toISOString()
        .slice(0, 10),
      workingHoursOptions: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      shiftNameOptions: [
        { value: "pagi", label: "Pagi" },
        { value: "pagi 2", label: "pagi 2" },
        { value: "pagi 3", label: "pagi 3" },
        { value: "siang", label: "Siang" },
        { value: "malam", label: "Malam" },
        { value: "malam 2", label: "malam 2" },
        { value: "malam 3", label: "malam 3" },
        { value: "middle", label: "Middle" },
      ],
      model: { name: "", id_kota: "", need_feedback: 0, working_hours: 8 },
      model_kota: [],
      markerCoordinates: [],

      popup_mode: "insert",
      data_store: [],
      no_section: 0,
      active_edit_section: 1,
      category_type: "cleaning",
      data_section: [],
      data_slot: [],
      data_shift: [],
      mp: { total: 1, job: "", msg_error: "", data: [] },
      sw: { name: "", hour: "", working_hours: 8, msg_error: "", data: [] },
      model_jobpos: [],
      meta_filter: { id_branch: "" },
      provinces_name: "",
      branch_name: "",
    };
  },
  computed: {
    ...mapState("crud", {
      msg_error: (state) => state.error,
    }),
    insertSections() {
      if (this.popup_mode !== "insert") return [];
      return this.data_section.filter(
        (section) => section.section == this.no_section
      );
    },
    editSections() {
      if (this.popup_mode !== "edit") return [];
      return this.data_section.filter(
        (section) => section.section == this.active_edit_section
      );
    },
  },
  created() {
    if (localStorage.getItem("userPrivilegesName") == "root") {
      this.isEnableSelectBranch = true;
    } else {
      this.model.id_branch = localStorage.getItem("userBranchId");
      this.branch_name = localStorage.getItem("userBranchName");
    }

    this.model.id_propinsi = localStorage.getItem("id_provinces");
    this.provinces_name = localStorage.getItem("provinces_name");
  },
  mounted() {
    this.fetchKota();
    this.QueryJobPosition();
    this.DataQuery();
  },
  methods: {
    OpenDialog(initial) {
      window.scrollTo(500, 0);
      this.isEnablePopup = initial;
    },
    processBranch(data) {
      this.model.id_branch = data;
    },
    closeClient() {
      this.isEnablePopup = false;
    },
    applyClient(data) {
      this.isAutoloadMaps = false;
      this.model.id_client = data.id;
      this.model.name = data.name;
      this.model.email = data.email;
      this.model.phone_number = data.phone_number;
      this.model.id_propinsi = data.id_propinsi;
      this.model.id_kota = data.id_kota;

      this.markerCoordinates = {
        latitude: parseFloat(data.lat),
        longitude: parseFloat(data.lng),
        address: data.office_address,
      };
      setTimeout(() => {
        this.isAutoloadMaps = true;
      }, 200);
    },
    AddShiftWork() {
      let model = this.sw.data;
      if (this.sw.name !== "" && this.sw.hour !== "" && this.sw.working_hours !== "") {
        if (this.isShiftNameUsed(this.sw.name)) {
          this.sw.msg_error = "Shift name already exists. Please choose a unique name !";
          return;
        }
        this.sw.msg_error = "";
        model.push({ name: this.sw.name, hour: this.sw.hour, working_hours: this.sw.working_hours });
        this.sw.name = "";
        this.sw.hour = "";
        this.sw.working_hours = 8;
      } else {
        this.sw.msg_error = "Please insert shift name, start hour, and working hours !";
      }
    },
    RemoveShiftWorker(idx) {
      let model = this.sw.data;
      model.splice(idx, 1);
    },
    isShiftNameUsed(name) {
      return this.sw.data.some(
        (shift) => shift.name.toLowerCase().trim() === name.toLowerCase().trim()
      );
    },
    isShiftNameUsedByOther(name, currentIndex) {
      const normalizedName = String(name || "").toLowerCase().trim();
      return this.sw.data.some(
        (shift, index) =>
          index !== currentIndex &&
          String(shift.name || "").toLowerCase().trim() === normalizedName
      );
    },
    isKnownShiftName(name) {
      const normalizedName = String(name || "").toLowerCase().trim();
      return this.shiftNameOptions.some(
        (shiftName) => shiftName.value === normalizedName
      );
    },
    normalizeShiftName(name) {
      return String(name || "").toLowerCase().trim();
    },
    contractSourceId() {
      return this.$route.query.contract_id || localStorage.getItem("QUERY_ID");
    },
    isDuplicateShift(name) {
      const normalizedName = String(name || "").toLowerCase().trim();
      return (
        normalizedName !== "" &&
        this.sw.data.filter(
          (shift) =>
            String(shift.name || "").toLowerCase().trim() === normalizedName
        ).length > 1
      );
    },
    parseArrayValue(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];

      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    duplicateShiftNames() {
      const names = {};

      return this.sw.data.reduce((duplicates, shift) => {
        const name = String(shift.name || "").toLowerCase().trim();
        if (!name) return duplicates;

        names[name] = (names[name] || 0) + 1;
        if (names[name] === 2) duplicates.push(name);
        return duplicates;
      }, []);
    },
    SaveSectionRoom() {
      let data_section = this.data_section;

      for (let key in data_section) {
        var data_bind = data_section[key].data;

        if (data_bind.length > 0) {
          var temp_data = [];
          for (let items in data_bind) {
            if (data_section[key].data[items].area_name !== "") {
              temp_data.push(data_section[key].data[items]);
            } else {
              alert("Please entry completely all room name");
              return;
            }
          }

          if (data_section[key]) {
            data_section[key].data = temp_data;
          }
        }
      }

      const currentSection = this.data_section.find(
        (section) =>
          section.section ==
          (this.popup_mode == "insert"
            ? this.no_section
            : this.active_edit_section)
      );
      if (currentSection) {
        currentSection.category_type = this.category_type;
      }

      // console.log(data_section);
      this.isEnablePopup = false;
    },
    AddMoreManPower() {
      // console.log(this.mp.data);
      let model = this.mp.data;
      this.mp.msg_error = "";
      if (this.mp.job !== "") {
        for (let key in model) {
          if (model[key].job == this.mp.job) {
            this.mp.msg_error = "Job position is already exists !";
            return;
          }
        }
        model.push({ total: this.mp.total, job: this.mp.job });
      } else {
        this.mp.msg_error = "Please choose job position !";
      }
    },
    RemoveManPower(idx) {
      let model = this.mp.data;
      model.splice(idx, 1);
    },
    AddMoreSection() {
      this.popup_mode = "insert";
      this.no_section = this.no_section + 1;
      this.active_edit_section = this.no_section;
      this.category_type = "cleaning";
      // console.log(this.data_section)
      this.data_section.push({
        section: this.no_section,
        category_type: this.category_type,
        data: [
          {
            section: "",
            area_type: "indoor",
            area_task: "",
            area_name: "",
            area_floor: 1,
          },
        ],
      });

      window.scrollTo(500, 0);
      this.isEnablePopup = "section";
    },
    EditSection(no) {
      this.popup_mode = "edit";
      this.active_edit_section = no;

      const section = this.data_section.find((item) => item.section == no);
      if (section) {
        this.category_type = section.category_type || "cleaning";
      }

      this.isEnablePopup = "section";
    },
    DeleteSection(no) {
      if (confirm("Continue remove section #" + (no + 1))) {
        this.data_section.splice(no, 1);
      }
    },
    AddMoreSlotRoom() {
      let model = this.data_slot;
      let data_section = this.data_section;
      let targetSection =
        this.popup_mode == "edit" ? this.active_edit_section : this.no_section;
      for (let idx in data_section) {
        if (data_section[idx].section == targetSection) {
          data_section[idx].data.push({
            section: 1,
            area_type: "indoor",
            area_task: "",
            area_name: "",
            area_floor: 1,
          });
        }
      }

      $("#add-more-notify").text("1 slot unit is already created.");
      $("#add-more-notify").show();
      setTimeout(() => {
        $("#add-more-notify").fadeOut();
      }, 1000);
    },
    removeSlotRoom(idx) {
      this.data_slot.splice(idx, 1);
    },

    QueryJobPosition() {
      axios
        .post("job_position/data/all")
        .then((res) => {
          this.model_jobpos = res.data;
        })
        .finally(() => {});
    },
    async DataQuery() {
      this.isAutoloadMaps = false;

      await axios
        .get(this.meta_url + "/find/" + this.contractSourceId())
        .then((res) => {
          let query = res.data;

          let dataMapping = query.data;
          let sectionMapping = query.section || {};

          this.sw.data = [];
          this.mp.data = [];
          this.data_section = [];

          this.model.id_branch = dataMapping.id_branch;
          this.model.contract_number = dataMapping.contract_number;
          this.model.contract_value = dataMapping.contract_value;
          this.model.contract_date = this.$moment(
            dataMapping.contract_date
          ).format("DD-MM-YYYY");
          this.model.description = dataMapping.description;

          this.model.id_client = dataMapping.id_client;
          this.model.name = dataMapping.client_name;
          this.model.email = dataMapping.email;
          this.model.phone_number = dataMapping.phone_number;
          this.model.id_propinsi = dataMapping.id_propinsi;
          this.model.id_kota = dataMapping.id_kota;
          this.markerCoordinates = {
            latitude: parseFloat(dataMapping.lat),
            longitude: parseFloat(dataMapping.lng),
            address: dataMapping.office_address,
          };

          setTimeout(() => {
            this.isAutoloadMaps = true;
          }, 200);

          // mapping ShiftWork Existing Contract Project
          let shifWorkMapping = this.parseArrayValue(dataMapping.contract_shift);
          if (shifWorkMapping.length > 0) {
            for (let key in shifWorkMapping) {
              this.sw.data.push({
                name: this.normalizeShiftName(shifWorkMapping[key].name),
                hour: shifWorkMapping[key].hour,
                working_hours: Number(shifWorkMapping[key].working_hours || dataMapping.working_hours || 8),
              });
            }
          }

          // mapping ManPower Existing Contract Project
          let manPower = this.parseArrayValue(dataMapping.man_power);
          // console.log(manPower.length)
          if (manPower.length > 0) {
            for (let key in manPower) {
              this.mp.data.push({
                total: manPower[key].total,
                job: manPower[key].job,
              });
            }
          }

          // mapping Section Existing Contract Project
          let counterSection = 0;
          for (let key in sectionMapping) {
            let lengthSection = sectionMapping[key].length;
            if (lengthSection > 0) {
              let temp_data = [];
              for (let i = 0; i < lengthSection; i++) {
                if (sectionMapping[key][i].section == key) {
                  temp_data.push(sectionMapping[key][i]);
                }
              }

              this.data_section.push({
                section: Number(key),
                category_type: temp_data[0].category_type || "cleaning",
                data: temp_data,
              });
              counterSection = Math.max(counterSection, Number(key));
            }
          }

          this.no_section = counterSection;

          // console.log(this.data_section);
        })
        .finally(() => {
          // this.$store.state.loading.status = false;
        });
    },
    async fetchKota() {
      this.model_kota = this.parseArrayValue(
        localStorage.getItem("data_regencies")
      );
    },
    switchClientBase() {
      if (this.isBaseClient == "new") {
        this.isAutoloadMaps = false;

        // reset default value model from old
        this.model.id_client = "";
        this.model.name = "";
        this.model.email = "";
        this.model.phone_number = "";

        this.model_kota = [];
        this.model.id_kota = "";
        this.model.id_propinsi = "";
        this.model.lat = "";
        this.model.lng = "";
        this.model.office_address = "";
        this.markerCoordinates = [];

        setTimeout(() => {
          this.isAutoloadMaps = true;
        }, 200);
      }
    },
    async submit(e) {
      e.preventDefault();

      if (this.isSubmitting) return; // prevent double submit

      const duplicateShifts = this.duplicateShiftNames();
      if (duplicateShifts.length > 0) {
        this.sw.msg_error =
          "Duplicate shift name found: " +
          duplicateShifts.join(", ") +
          ". Remove the duplicate and add it again using a unique name.";
        this.isEnablePopup = "shiftwork";
        window.scrollTo(0, 0);
        return;
      }

      this.sw.msg_error = "";
      this.isSubmitting = true;
      this.$store.state.loading.msg = "Process Renew Data...";
      this.$store.state.loading.status = true;

      this.model.contract_id_old = this.contractSourceId();

      this.model.isBaseClient = this.isBaseClient;
      this.model.man_power = this.mp.data;
      this.model.shift = this.sw.data;
      this.model.working_hours = this.sw.data.length
        ? this.sw.data[0].working_hours
        : this.model.working_hours;

      // rewrite data DOM  parsing to model
      this.model.office_address =
        document.getElementById("input_address").value;
      this.model.lat = document.getElementById("input_lat").value;
      this.model.lng = document.getElementById("input_lon").value;
      this.model.data_slot = this.data_section;
      this.model.contract_date = this.$moment(this.sdate).format("DD-MM-YYYY");

      // start date and end date
      var sdate = document.getElementById("startDate").value;
      var edate = document.getElementById("endDate").value;
      this.model.start_date =
        sdate == "" ? "" : this.$moment(sdate).format("DD-MM-YYYY");
      this.model.end_date =
        edate == "" ? "" : this.$moment(edate).format("DD-MM-YYYY");

      // console.log(this.model);
      let data = {
        url: this.meta_url + "/store",
        callback_url: "jobcon/contract-data",
        callback_query: this.contractListQuery(),
        form_data: this.model,
      };

      // console.log(data);

      let res = await this.$store.dispatch("crud/storeData", data);

      // console.log(res);

      // if (res.data.result == "ok") {
      //   this.isSubmitting = false;
      // }
      setTimeout(() => {
        this.isSubmitting = false;
        this.$store.state.loading.status = false;
      }, 1500);
    },
    contractListQuery() {
      const query = Object.assign({}, this.$route.query);
      delete query.contract_id;
      return query;
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-create-page {
  color: #293b4f;
}
.contract-create-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(20, 77, 126, 0.18);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  min-height: 150px;
  overflow: hidden;
  padding: 28px 34px;
  position: relative;
}
.contract-create-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 230px;
  position: absolute;
  right: -55px;
  top: -90px;
  width: 230px;
}
.contract-create-hero small {
  color: #8ff3e8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
}
.contract-create-hero h3 {
  color: #fff;
  font-size: 24px;
  margin: 5px 0 4px;
}
.contract-create-hero p {
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}
.contract-create-hero-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 14px;
  display: flex;
  font-size: 34px;
  height: 72px;
  justify-content: center;
  position: relative;
  width: 72px;
  z-index: 1;
}
.contract-create-card {
  border: 1px solid #e3eaf1;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(33, 55, 79, 0.08);
  overflow: hidden;
}
.contract-create-card .card-body {
  padding: 0;
}
.contract-create-form > .contract-create-card::v-deep .form-control {
  border: 1px solid #d6e0e9;
  border-radius: 7px;
  min-height: 42px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.contract-create-form > .contract-create-card::v-deep .form-control:focus {
  border-color: #188ac2;
  box-shadow: 0 0 0 3px rgba(24, 138, 194, 0.12);
}
.contract-create-form .form-group {
  align-items: flex-start;
  display: flex;
  float: none;
  flex-wrap: wrap;
  margin: 0;
  padding: 10px 30px;
  width: 100%;
}
.contract-create-form .form-group > label {
  color: #45586d;
  font-size: 12px;
  font-weight: 600;
  padding-top: 11px;
}
.contract-create-form .form-group textarea.form-control {
  min-height: 90px;
}
.contract-create-form .contract-map-row > .col-sm-9 {
  background: #f8fafc;
  border: 1px solid #dfe7ef;
  border-radius: 10px;
  padding: 16px;
}
.contract-section-heading {
  background: linear-gradient(90deg, #f2f8fd 0%, #fbfdff 100%);
  border-bottom: 1px solid #e1eaf2;
  border-top: 1px solid #e1eaf2;
  margin-top: 20px !important;
  padding-bottom: 18px !important;
  padding-top: 18px !important;
}
.contract-section-heading:first-child {
  border-top: 0;
  margin-top: 0 !important;
}
.contract-section-heading label {
  color: #1e5f92 !important;
  display: block;
  font-size: 15px !important;
  font-weight: 700 !important;
  padding: 0 !important;
}
.contract-section-heading small {
  display: block;
  margin-top: 4px;
}
.contract-section-heading hr {
  display: none;
}
.contract-config-row {
  align-items: flex-start;
  background: #f9fbfd;
  border: 1px solid #e1e8ef;
  border-radius: 9px;
  display: flex;
  float: left;
  margin: 10px 30px 4px !important;
  padding: 18px 8px;
  width: calc(100% - 60px);
}
.contract-config-row .badge {
  border-radius: 999px;
  padding: 5px 8px;
}
.contract-config-row .btn-light {
  background: #fff;
  border: 1px solid #d7e1ea;
  border-radius: 7px;
  box-shadow: 0 3px 8px rgba(31, 67, 99, 0.06);
}
.contract-area-config > .row {
  flex: 0 0 100%;
  margin-left: 0;
  margin-right: 0;
  max-width: 100%;
  width: 100%;
}
.contract-area-config {
  flex-wrap: wrap;
}
.contract-area-config h5 {
  color: #334b63;
  font-size: 13px;
}
.contract-create-form .list-section {
  background: #fff;
  border: 1px solid #e3e9ef;
  border-radius: 6px;
  color: #647486;
  margin-bottom: 6px;
  padding: 9px 11px;
}
.contract-create-actions {
  background: #fff;
  border: 1px solid #e3eaf1;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(33, 55, 79, 0.08);
  margin: 18px 0 36px;
  padding: 18px 22px;
}
.contract-create-actions .btn {
  border-radius: 7px;
  min-width: 140px;
  padding: 10px 18px;
}
.shift-hours-select {
  display: inline-block;
  margin: 0 8px;
  padding: 4px 8px;
  width: 105px;
}
.legacy-shift-warning {
  background: #fff8e6;
  border: 1px solid #f1d58a;
  border-radius: 8px;
  color: #7a5a00;
  margin-bottom: 16px;
  padding: 12px 14px;
}
.legacy-shift-warning strong,
.legacy-shift-warning span {
  display: block;
}
.legacy-shift-warning span {
  font-size: 12px;
  margin-top: 3px;
}
.legacy-shift-warning--summary {
  margin-bottom: 0;
  max-width: 720px;
}
.renewal-shift-row {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e0e8ef;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  padding: 10px;
}
.renewal-shift-row--duplicate {
  background: #fff9ea;
  border-color: #efcf73;
}
.shift-name-select,
.renewal-shift-row .shift-hours-select {
  border: 1px solid #d5dfe8;
  border-radius: 6px;
  height: 36px;
}
.shift-name-select {
  background: #fff;
  min-width: 150px;
  padding: 4px 8px;
}
.shift-time-label {
  background: #edf3f7;
  border-radius: 6px;
  min-width: 72px;
  padding: 8px 10px;
  text-align: center;
}
.renewal-shift-row .shift-hours-select {
  margin: 0;
}
.renewal-shift-row .ti-trash {
  cursor: pointer;
  margin-left: auto;
  padding: 8px;
}
.contract-create-modal {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  margin: 0;
  overflow-y: auto;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0 !important;
  width: 100vw;
  z-index: 1200;
}
.contract-create-modal::before {
  z-index: 0;
}
.contract-create-modal .content,
.contract-create-modal--client::v-deep .content {
  border-radius: 12px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.25);
  float: none;
  margin: auto;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 24px 28px;
  width: 100%;
}
.contract-create-modal--compact .content {
  max-width: 640px;
}
.contract-create-modal--shift .content {
  max-width: 760px;
}
.contract-create-modal--section .content {
  max-width: 900px;
}
.contract-create-modal--client::v-deep .content {
  max-width: 1180px;
}
#add-more-notify {
  display: none;
}
.area-section {
  background-color: whitesmoke;
}
.list-data {
  position: relative;
  float: left;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  .ti {
    position: absolute;
    right: 10px;
    top: 15px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
}

.list-section {
  width: 100%;
  float: left;
  border-bottom: 1px solid whitesmoke;
  padding: 10px;
}

.disabled-button {
  cursor: progress !important;
  opacity: 0.7;
  pointer-events: none;
}

@media (max-width: 767px) {
  .contract-create-hero {
    margin-bottom: 14px;
    min-height: 132px;
    padding: 22px 20px;
  }
  .contract-create-hero h3 {
    font-size: 20px;
  }
  .contract-create-hero p {
    font-size: 11px;
    max-width: 270px;
  }
  .contract-create-hero-icon {
    display: none;
  }
  .contract-create-form .form-group {
    display: block;
    padding: 9px 16px;
  }
  .contract-create-form .form-group > [class*="col-"] {
    float: none;
    padding-left: 0;
    padding-right: 0;
    width: 100%;
  }
  .contract-create-form .form-group > label {
    display: block;
    padding: 0 0 6px;
    width: 100%;
  }
  .contract-section-heading {
    padding: 16px !important;
  }
  .contract-config-row {
    display: block;
    margin: 10px 16px 4px !important;
    padding: 16px 6px;
    width: calc(100% - 32px);
  }
  .contract-config-row > [class*="col-"] {
    float: none;
    margin-bottom: 12px;
    width: 100%;
  }
  .contract-create-actions {
    margin: 14px 0 24px;
    padding: 14px;
  }
  .contract-create-actions .col-md-12 {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    padding: 0;
  }
  .contract-create-actions .btn {
    margin: 0 !important;
    text-align: center;
    width: 100%;
  }
  .contract-create-modal {
    align-items: flex-start;
    padding: 14px;
  }
  .contract-create-modal .content,
  .contract-create-modal--client::v-deep .content {
    margin: 0;
    max-height: calc(100vh - 28px);
    padding: 20px 16px;
  }
  .renewal-shift-row {
    align-items: stretch;
    flex-direction: column;
  }
  .shift-name-select,
  .shift-time-label,
  .renewal-shift-row .shift-hours-select {
    margin: 0;
    width: 100%;
  }
  .renewal-shift-row .ti-trash {
    align-self: flex-end;
    margin-left: 0;
  }
}
</style>
